import { Component } from '@angular/core';
import { InfiniteScroll, NavController, NavParams, ViewController } from 'ionic-angular';
import { Subject } from 'rxjs';

import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { LoadingAlertProvider } from '../../providers/loading-alert/loading-alert';
import { OpsProvider } from '../../providers/ops/ops';
import { TruckModel } from '../../models/truck';


@Component({
  selector: 'page-trucks',
  templateUrl: 'trucks.html',
})
export class TrucksPage {
  trucks: TruckModel[] = [];
  filteredTrucks: TruckModel[] = [];
  selectedTruck: TruckModel;
  isModal: boolean;
  preventGlobalSelection = false;
  pageNumber: number = 0;
  searching: boolean = false;
  onSelect: (truck: TruckModel) => void;
  private unsubscribe: Subject<void> = new Subject();
  private infiniteScroll: InfiniteScroll;
  private completeTrucksList: TruckModel[] = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private opsService: OpsProvider,
    private analytics: AnalyticsProvider,
    private loadingAlertCtrl: LoadingAlertProvider,
    private viewCtrl: ViewController
  ) {
    this.isModal = this.navParams.get('isModal');
    this.onSelect = this.navParams.get('onSelect');
    this.preventGlobalSelection = this.navParams.get('preventGlobalSelection');
    this.selectedTruck = this.navParams.get('selectedTruck');
    this.opsService
      .getTrucks(null, false)
      .subscribe(trucks => (this.completeTrucksList = trucks));
    if (!this.preventGlobalSelection) {
      this.opsService.selectedTruck$
        .takeUntil(this.unsubscribe)
        .subscribe((truck: TruckModel) => (this.selectedTruck = truck));
    }
    this.getTrucks();
  }

  ionViewDidLoad() {
    this.analytics.trackView('TrucksPage');
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  //data
  getTrucks() {
    if (this.pageNumber === 0)
      this.loadingAlertCtrl.showLoaderWithText('Loading Trucks');
    this.pageNumber++;
    this.opsService
      .getTrucks(this.pageNumber)
      .finally(() => this.loadingAlertCtrl.dismissLoader())
      .subscribe(trucks => {
        this.trucks.push(...trucks);
        if (this.infiniteScroll) this.infiniteScroll.complete();
        if (!trucks.length) {
          this.pageNumber--;
          this.infiniteScroll.enable(false);
        } else if (this.pageNumber === 1) {
          // Load second page automatically to avoid a bug on larger viewports
          // https://github.com/ionic-team/ionic-v3/issues/59
          this.getTrucks();
        }
      });
  }

  getNextPage(infiniteScroll: InfiniteScroll) {
    this.infiniteScroll = infiniteScroll;
    this.getTrucks();
  }

  //actions
  onSearchInput(event) {
    let searchQuery = event.target.value;
    this.searching = !searchQuery || !searchQuery.trim() ? false : true;
    if (!this.searching) {
      return;
    }
    searchQuery = searchQuery && searchQuery.toLowerCase();
    this.filteredTrucks = this.getFilteredTrucks(searchQuery);
  }

  didCancelSearch() {
    this.searching = false;
  }

  didTapDismiss() {
    this.dismiss();
  }

  didTapBack() {
    this.navCtrl.pop();
  }

  didSelectTruck(truck: TruckModel) {
    this.onSelect && this.onSelect(truck);
    !this.preventGlobalSelection && this.opsService.setSelectedTruck(truck);
    this.isModal && this.dismiss();
  }

  //helpers
  dismiss() {
    this.isModal ? this.viewCtrl.dismiss() : this.navCtrl.pop();
  }

  getFilteredTrucks(query) {
    return this.completeTrucksList.filter(truck => {
      if (truck.name) {
        return truck.name.toLowerCase().indexOf(query) > -1;
      } else {
        return false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/trucks/trucks.ts